import {
  FETCH_SEARCH_BAR_PRODUCTS,
  FETCH_SEARCH_BAR_PRODUCTS_FAILED,
  FETCH_SEARCH_BAR_PRODUCTS_SUCCESS,
  type Action as ProductsSuggestionsAction,
} from '@/domains/productDiscovery/HeaderLeonidas/modules/productSuggestions/modules/searchResults/actions';
import { mapAlgoliaHitToProductCardData } from '@/productDiscovery/HeaderLeonidas/modules/productSuggestions/services/algolia/mapAlgoliaHitToProductCardData';

import { Status } from '../../productSuggestions/modules/searchResults/constants';
import { HISTORY_MAX_LENGTH } from '../components/Search/utils/searchHistory/constants';
import { getSearchHistory } from '../components/Search/utils/searchHistory/get';
import {
  GET_AUTO_COMPLETE_SUGGESTIONS_FAILED,
  GET_AUTO_COMPLETE_SUGGESTIONS_SUCCESS,
  RESET_AUTO_COMPLETE_SUGGESTIONS,
  UPDATE_SUGGESTIONS_HISTORY,
  type Action,
} from '../HeaderLeonidas.searchBar.actions';
import type { AutoCompleteSuggestions } from '../interfaces/suggestions';
import { buildSuggestionsGroup } from '../utils/buildSuggestionsGroup';
import { updateSuggestions } from '../utils/updateSuggestions';

export default function reducer(
  state: AutoCompleteSuggestions = {},
  action: Action | ProductsSuggestionsAction,
): AutoCompleteSuggestions {
  switch (action.type) {
    case GET_AUTO_COMPLETE_SUGGESTIONS_SUCCESS: {
      const { termQuery, resultsQueries } = action;
      const history = getSearchHistory(HISTORY_MAX_LENGTH);

      return {
        ...state,
        queries:
          resultsQueries.queries &&
          buildSuggestionsGroup({
            hits: resultsQueries.queries.hits,
            index: resultsQueries.queries.index,
            queryID: resultsQueries.queries.queryID,
            history,
            termQuery,
            highlight: true,
            type: 'query',
            autocomplete: true,
          }),
        categories:
          resultsQueries.categories &&
          buildSuggestionsGroup({
            hits: resultsQueries.categories.hits,
            index: resultsQueries.categories.index,
            queryID: resultsQueries.categories.queryID,
            termQuery,
            highlight: true,
            type: 'category',
          }),
        brands:
          resultsQueries.brands &&
          buildSuggestionsGroup({
            hits: resultsQueries.brands.hits,
            index: resultsQueries.brands.index,
            queryID: resultsQueries.brands.queryID,
            termQuery,
            type: 'brand',
          }),
      };
    }

    case GET_AUTO_COMPLETE_SUGGESTIONS_FAILED:
    case RESET_AUTO_COMPLETE_SUGGESTIONS:
      return {
        ...state,
        queries: undefined,
        brands: undefined,
        categories: undefined,
      };

    case UPDATE_SUGGESTIONS_HISTORY: {
      const history = getSearchHistory(HISTORY_MAX_LENGTH);

      return {
        ...state,
        queries: {
          items: updateSuggestions(history, state?.queries?.items),
        },
      };
    }

    case FETCH_SEARCH_BAR_PRODUCTS:
      return {
        ...state,
        products: {
          ...state.products,
          status: Status.FETCHING,
        },
      };

    case FETCH_SEARCH_BAR_PRODUCTS_SUCCESS: {
      const { results } = action;
      return {
        ...state,
        products: {
          items: mapAlgoliaHitToProductCardData(results.hits),
          status: Status.DONE,
          queryDetails: {
            index: results.index,
            queryID: results.queryID,
          },
          nbHits: results.nbHits,
        },
      };
    }
    case FETCH_SEARCH_BAR_PRODUCTS_FAILED:
      return {
        ...state,
        products: {
          status: Status.ERROR,
        },
      };

    default:
      return state;
  }
}
